// response data를 카멜케이스로 변환해주는 함수
export const camelCased = (items) => {
  if (Array.isArray(items)) {
    return items.map((item) => camelCased(item))
  } else if (items !== null && typeof items === 'object') {
    const nItem = {}
    Object.keys(items).forEach((key) => {
      const camelCase = key.replace(/[-_]+(.)?/g, (m, w) => w.toUpperCase())
      if (Array.isArray(items[key])) {
        nItem[camelCase] = items[key].map((subItem) => camelCased(subItem))
      } else if (items[key] !== null && typeof items[key] === 'object') {
        nItem[camelCase] = camelCased(items[key])
      } else {
        nItem[camelCase] = items[key]
      }
    })
    return nItem
  } else {
    return items
  }
}

// 변경된 quryString을 적용된 url을 반환해주는 함수
export const updateRouteUrl = (originalUrl, updatedValues) => {
  const baseUrl = originalUrl.split('?')[0]
  const originalQueryObject = queryStringToObject(originalUrl)
  const queryOrder = ['mainCode', 'subCode', 'orderby', 'genre', 'page']

  const mergedQueryObject = {}
  queryOrder.forEach((queryName) => {
    if (updatedValues.hasOwnProperty(queryName)) {
      mergedQueryObject[queryName] = updatedValues[queryName]
      delete updatedValues[queryName]
    } else if (originalQueryObject.hasOwnProperty(queryName)) {
      mergedQueryObject[queryName] = originalQueryObject[queryName]
    }
  })
  Object.assign(mergedQueryObject, updatedValues)

  const newQueryString = objectToQueryString(mergedQueryObject)
  const newUrl = `${baseUrl}?${newQueryString}`

  return newUrl
}

// URL에 존재하는 queryString들을 Object로 변환해주는 함수
export const queryStringToObject = (url) => {
  const queryString = url.split('?')[1]
  const params = new URLSearchParams(queryString)
  const obj = {}

  params.forEach((value, key) => {
    obj[key] = value
  })

  return obj
}

// queryString을 Object로 파싱해주는 함수
export const parseQueryString = (url) => {
  const queryStartIndex = url.indexOf('?')
  if (queryStartIndex === -1) return {}

  const queryString = url.substring(queryStartIndex + 1)

  const keyValuePairs = queryString
    .split('&')
    .map((pair) => pair.split('='))
    .reduce((acc, [key, value]) => {
      acc[key] = value ? decodeURIComponent(value) : value
      return acc
    }, {})

  return keyValuePairs
}

// Object를 queryString으로 변환해주는 함수
export const objectToQueryString = (obj) => {
  const params = new URLSearchParams()
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      params.append(key, obj[key])
    }
  }
  return params.toString()
}

// 선택한 쿼리스트링만 업데이트해주는 함수
export const updateQueryParam = (url, paramName, paramValue) => {
  const [baseUrl, queryString] = url.split('?')
  const searchParams = new URLSearchParams(queryString)

  searchParams.set(paramName, paramValue)

  return `${baseUrl}?${searchParams.toString()}`
}
